import { Shipping } from '@nemuru-eng/js-api-client';

import { ShippingForm } from '@/components/modules/ShippingAndBilling/_shared/components/ShippingDetails/components/ShippingForm';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { PendingDataType } from '@/config/types';

export const ShippingDetails = ({ shipping }: { shipping: Shipping | null }) => {
  return (
    <SubSectionWrapper title={'SHIPPING_ADDRESS'}>
      {shipping ? (
        <>
          <ShippingForm shipping={shipping} />
        </>
      ) : (
        <PendingDataWarning type={PendingDataType.ADDRESS} />
      )}
    </SubSectionWrapper>
  );
};
